// extracted by mini-css-extract-plugin
module.exports =  {"container":"_7506d987b5--container--__OuT","text":"_7506d987b5--text--YQtwk","image":"_7506d987b5--image--ckJkW","description":"_7506d987b5--description--MuKpA"};